<template>
    <div class="dabutton" :class="['dabutton1-' + device]" :style="{background:background,color:color,border:'1px solid '+borderColor}" @click="submit">
        {{ text }}
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    export default{
        name:'ButtonVue',
        props:{
            text:{
                type:String,
                default:'提交'
            },
            background:{
                type:String,
                default:'#004098'
            },
            borderColor:{
                type:String,
                default:'#004098'
            },
            color:{
                type:String,
                default:'#ffffff'
            }
        },
        computed: {
            ...mapState({
            device: state => state.app.device
            }),
        },
        data(){
            return {

            }
        },
        methods:{
            submit(){
                this.$emit('submit')
            }
        }
    }
</script>
<style lang="scss" scoped>
.dabutton{
    width: 169px;
    height: 53px;
    background: #004098;
    border-radius: 60px 60px 60px 60px;
    text-align: center;
    line-height: 53px;
    margin-right: 20px;
    cursor: pointer;
}
.dabutton-mobile{
  width: 3.38rem;
  height: 0.86rem;
  list-style: 0.86rem;
  border-radius: 1.2rem; 
  margin-right:0.4rem ;
  font-size: 0.38rem;
}
</style>